import * as Icons from "lucide-react";

// Renders a lucide-react icon by string name, with a safe fallback.
export default function Icon({ name, className, strokeWidth = 2, ...rest }) {
  const Cmp = Icons[name] || Icons.Sparkles;
  return <Cmp className={className} strokeWidth={strokeWidth} aria-hidden="true" {...rest} />;
}
